import React from 'react';
import {FilterSelect} from './FilterSelect';
import {
  PrimaryBusinessCategory,
  PrimaryBusinessCategoryLabels,
} from '../../../shared/account';
import {keys} from '../../../shared/util';
import {FilterControlWithNegate} from './FilterControlWithNegate';

const primaryCategoryOptions = keys(PrimaryBusinessCategoryLabels).map(
  (value) => ({
    value,
    label: PrimaryBusinessCategoryLabels[value],
  })
);

export const CategoriesFilterControl = ({
  value,
  negate,
  onChange,
  onRemove,
}: {
  value: PrimaryBusinessCategory[];
  negate?: boolean;
  onChange: (value: PrimaryBusinessCategory[], negate?: boolean) => void;
  onRemove: () => void;
}) => {
  const selectedOptions = value.map((v) => ({
    value: v,
    label: PrimaryBusinessCategoryLabels[v],
  }));

  return (
    <FilterControlWithNegate
      value={value}
      negate={negate}
      onChange={onChange}
      onRemove={onRemove}
    >
      {(_, onValueChange) => (
        <FilterSelect
          options={primaryCategoryOptions}
          isMulti
          onChange={(values) => {
            onValueChange(
              values.map((v) => v.value) as PrimaryBusinessCategory[]
            );
          }}
          value={selectedOptions}
        />
      )}
    </FilterControlWithNegate>
  );
};
